import React from 'react';
import { Box, Stack } from '@mui/material';
import { useParams, useLocation } from 'react-router-dom';
import { RoomGrid } from '../grids';
import { AddRoomDialog } from '../dialogs';
import { useGetRoomsQuery } from '../../../../services/ConfigurationService';

export const RoomsTab: React.FC = () => {
  const { id: centerId } = useParams<{ id: string }>();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const company = queryParams.get('company') || '';

  const {
    data: rooms = [],
    refetch: refetchRooms
  } = useGetRoomsQuery({ centerId: centerId || '' });
  return (
    <Stack spacing={3}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <AddRoomDialog
          defaultCenterId={centerId || ''}
          onSuccess={refetchRooms}
        />
      </Box>
      <RoomGrid
        rooms={rooms}
        centerId={centerId || ''}
        onRoomSaved={refetchRooms}
      />
    </Stack>
  );
};